const getLocalStorage = (key: string): string | null => {
  return localStorage.getItem(key);
};

const setLocalStorage = (key: string, payload: string | object): void => {
  localStorage.setItem(
    key,
    typeof payload === 'object' ? JSON.stringify(payload) : payload
  );
};

const setLocalStorageObject = (obj: Record<string, string | object>): void => {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const payload = obj[key];
      localStorage.setItem(
        key,
        typeof payload === 'object' ? JSON.stringify(payload) : payload
      );
    }
  }
};

const clearLocalByKey = (key: string): void => {
  return localStorage.removeItem(key);
};

export {
  getLocalStorage,
  setLocalStorage,
  setLocalStorageObject,
  clearLocalByKey
};
